const statusColors = {

    error : {
        lineColors : [
            '#bb3333',
            '#993333',
            '#881111',
            '#661111',
            '#550000',
            '#440000',
        ],

        gridColor   : '#ffbbbb',
        labelColor  : '#440000'
    },

    warning : {
        lineColors : [
            '#bb9933',
            '#997733',
            '#886611',
            '#664411',
            '#553300',
            '#441100',
        ],

        gridColor   : '#ffffbb',
        labelColor  : '#444400'
    },

    ok : {
        lineColors : [
            '#33bb33',
            '#339933',
            '#118811',
            '#116611',
            '#005500',
            '#004400',
        ],

        gridColor   : '#bbffbb',
        labelColor  : '#004400'
    },

    default : {
        lineColors : [
            '#bbbbbb',
            '#999999',
            '#888888',
            '#666666',
            '#555555',
            '#444444',
        ],

        gridColor   : '#eeeeee',
        labelColor  : '#444444'
    }

};


class StatusHelper
{
    static getStatusColors( status )
    {
        return statusColors.hasOwnProperty( status ) ? statusColors[ status ] : statusColors.default;
    }

    static getStatusIconName( status )
    {
        switch( status )
        {
            case 'error':
                return 'remove circle';

            case 'warning':
                return 'warning sign';

            case 'ok':
                return 'checkmark';

            default:
                return 'info circle';
        }
    }
}

export default StatusHelper;



// WEBPACK FOOTER //
// ./src/lib/status-helper.js